'use strict';

/**
 *
 * @name: apiUserService
 *
 */

function apiUserService(
  $rootScope,
  $http,
  $q,
  $location,
  $localStorage,
  $sessionStorage,
  ipCookie,
  $state,
  $stateParams,
  localPlaylist,
  apiNotificationsService
) {

  'ngInject';

  /**
   *
   * @PUBLIC
   *
   */

  $rootScope.isLocalStorageSupported = _isLocalStorageNameSupported();
  $rootScope.isSessionStorageSupported = _isSessionStorageNameSupported();

  if ($rootScope.isLocalStorageSupported) {

    $localStorage.Nowness = $localStorage.Nowness || {};
  }

  if ($rootScope.isSessionStorageSupported) {

    $sessionStorage.Nowness = $sessionStorage.Nowness || {};
  }

  var loginStatus = false;
  var redirectAfterLogin = null;

  function checkToken() {

    if ($rootScope.token) {

      return true;
    } else if ($rootScope.isLocalStorageSupported && $localStorage.Nowness.user && Object.keys($localStorage.Nowness.user).length > 0) {

      $rootScope.token = {
        subscriptions: $localStorage.Nowness.user.subscriptions,
        token: $localStorage.Nowness.user.token,
        id: $localStorage.Nowness.user.id
      };
      return true;
    } else if ($rootScope.isSessionStorageSupported && $sessionStorage.Nowness.user && Object.keys($sessionStorage.Nowness.user).length > 0) {

      $rootScope.token = {
        subscriptions: $sessionStorage.Nowness.user.subscriptions,
        token: $sessionStorage.Nowness.user.token,
        id: $sessionStorage.Nowness.user.id
      };
      return true;
    } else {

      $rootScope.profile = false;
      return false;
    }
  }

  function deleteLoginSession(id) {

    var target = $rootScope.apiUrlBak + '/login-session/' + id;

    return $http.delete(target);
  }

  function deleteUser() {

    var target = $rootScope.apiUrlNew + '/user/' + $rootScope.profile.id;

    return $http.delete(target);
  }

  function follow(followedId) {

    var data = {
      FollowerId: $rootScope.profile.id,
      FollowedId: followedId
    };

    if ($rootScope.profile && followedId !== $rootScope.profile.id) {

      return $http.post($rootScope.apiUrlBak + '/following', data);
    } else {

      var deferred = $q.defer();
      deferred.reject('cannae');
      return deferred.promise;
    }
  }

  function followDelete(followedId) {

    var target = $rootScope.apiUrlBak + '/following?' +
      '&FollowerId=' + $rootScope.profile.id +
      '&FollowedId=' + followedId;

    return $http.delete(target);
  }

  function getTokenAsAdmin(user) {

    var target = $rootScope.apiUrlNew + '/token';
    var options = {
      headers: {
        'x-Nowness-Cms-Request': true,
        'X-Nowness-Language': 'en-us,zh-cn,zh-hk'
      }
    };

    return $q(function(resolve, reject) {

      $http
        .post(target, user, options)
        .success(function(response) {
          var token, isAdmin;

          isAdmin = response.roles.indexOf('superadmin') > -1 ||
            response.roles.indexOf('admin') > -1 ||
            response.roles.indexOf('editor') > -1;

          if (!isAdmin) {
            reject({
              message: 'You are not authorized to see this resources'
            });
          }

          // clear regular user token to nor overwrite admin token
          _clearUserData();

          token = {
            token: response.token,
            id: response.id,
            isAdmin: isAdmin
          };
          $localStorage.NownessAdmin = $localStorage.NownessAdmin || {};
          $localStorage.NownessAdmin.user = token;
          resolve(response);
        })
        .error(function(error) {

          reject(error);
        });
    });
  }

  function logOutAdmin() {

    if ($localStorage.NownessAdmin) {

      delete $localStorage.NownessAdmin;
    }
  }

  function isAdminAuthenticated() {

    return $localStorage.NownessAdmin &&
      $localStorage.NownessAdmin.user &&
      $localStorage.NownessAdmin.user.isAdmin;
  }

  function getTokenAndUser(user, remember) {

    var deferred = $q.defer();
    var options = {};
    var target = $rootScope.apiUrlNew + '/token';

    if (typeof user === 'string') {
      options.headers = {
        Authorization: user
      };
      user = {};
    }

    $http
      .post(target, user, options)
      .success(function(data) {

        //destroy admin session if one exists
        logOutAdmin();

        $rootScope.token = {
          token: data.token,
          id: data.id,
          bookmarks: data.bookmarks,
          subscriptions: data.subscriptions
        };

        if ($rootScope.isLocalStorageSupported && remember) {

          $localStorage.Nowness.user = $rootScope.token;
        } else if ($rootScope.isSessionStorageSupported) {

          $sessionStorage.Nowness.user = $rootScope.token;
        }

        loginStatus = true;
        deferred.resolve(getUser());
      })
      .error(function(data) {

        $rootScope.profile = false;
        deferred.reject(data);
      });

    return deferred.promise;
  }

  function getUser() {

    var deferred = $q.defer();
    var target = $rootScope.apiUrlNew + '/user/' + $rootScope.token.id;

    $http.get(target)
      .success(function(data) {

        if (data.email) {
          data.emailSet = true;
        }

        data.sNProfiles = [];

        data.loginSessions.forEach(function(item, index) {
          data.sNProfiles[index] = item.loginProvider;
        });

        $rootScope.profile = data;
        loginStatus = true;
        $rootScope.threeTimesAVirgin = 5;

        if (redirectAfterLogin && $state.current.name) {
          var target = redirectAfterLogin.valueOf()
          setRedirectAfterGettingUser({ to: null })
          $location.path(target);
        }

        localPlaylist
          .getCurrentPlaylist()
          .then(function() {

            deferred.resolve('ok - user and profile set');
          }, function(err) {

            deferred.reject(err);
          });
      })
      .error(function() {

        if ($rootScope.isLocalStorageSupported) {

          $localStorage.Nowness.user = {};
          $localStorage.Nowness.playlist = $rootScope.playlist;
        }

        if ($rootScope.isSessionStorageSupported) {

          $sessionStorage.Nowness.user = {};
          $sessionStorage.Nowness.playlist = $rootScope.playlist;
        }

        $rootScope.profile = false;
        deferred.reject('API error?');
      });

    return deferred.promise;
  }

  function getAnotherUser(UserId) {

    var target = $rootScope.apiUrlNew + '/user/' + UserId;

    return $http.get(target);
  }

  function listUsers(
    page,
    limit,
    role,
    order,
    isFollowing,
    isNotFollowing,
    isFollowedBy,
    isNotFollowedBy,
    professionId,
    isSocialFriendOf,
    isExTeam
  ) {

    var target = $rootScope.apiUrlNew + '/user?' +
      '&page=' + (page ? page : 1) +
      '&limit=' + (limit ? limit : 5) +
      (role ? '&role=' + role.toString() : '') +
      (order ? '&order=' + order : '') +
      (isFollowing ? '&isFollowing=' + isFollowing : '') +
      (isNotFollowing ? '&isNotFollowing=' + isNotFollowing : '') +
      (isFollowedBy ? '&isFollowedBy=' + isFollowedBy : '') +
      (isNotFollowedBy ? '&isNotFollowedBy=' + isNotFollowedBy : '') +
      (professionId ? '&ProfessionId=' + professionId : '') +
      (isSocialFriendOf ? '&isSocialFriendOf=' + isSocialFriendOf : '') +
      ((typeof isExTeam !== 'undefined' && isExTeam !== null) ? '&isExTeam=' + isExTeam : '');

    return $http.get(target);
  }

  function logout() {

    var _proceed = function() {

      _clearUserData();

      $state.transitionTo('main.home', $stateParams, {
        reload: true,
        inherit: false,
        notify: true
      });

      $location.path('/');
    };

    if ($state.current.name === 'main.ucp.accountFeed') {

      apiNotificationsService
        .markAsRead()
        .then(function() {

          _proceed();
        }, function() {

          _proceed();
        });
    } else {

      _proceed();
    }
  }

  function _clearUserData() {

    $rootScope.profile = false;
    apiNotificationsService.removePolling();

    delete $rootScope.token;
    delete $rootScope.playlist.items;
    delete $rootScope.playlist.idList;

    $rootScope.playlist = {};
    $rootScope.playlist.items = [];
    $rootScope.playlist.idList = [];
    $rootScope.playlist.settings = {};
    $rootScope.threeTimesAVirgin = 0;

    if ($rootScope.isLocalStorageSupported) {
      $localStorage.Nowness.user = {};
      $localStorage.Nowness.playlist = $rootScope.playlist;
      $localStorage.Nowness.playlist.threeTimesAVirgin = 0;
    }

    if ($rootScope.isSessionStorageSupported) {
      $sessionStorage.Nowness.user = {};
      $sessionStorage.Nowness.playlist = $rootScope.playlist;
    }

    $rootScope.remindMe = false;
    loginStatus = false;
  }

  function merge(source, socialToken) {

    var data = {
      source: source,
      socialToken: socialToken
    };

    var target = $rootScope.apiUrlNew + '/user/' + $rootScope.profile.id + '/login-session';

    return $http.post(target, data);
  }

  function register(user, remember) {

    var deferred = $q.defer();
    var target = $rootScope.apiUrlNew + '/user';

    $http.post(target, user)
      .success(function(data, status) {

        $rootScope.token = {
          token: data.token,
          id: data.id
        };

        if ($rootScope.isLocalStorageSupported && remember) {

          $localStorage.Nowness.user = $rootScope.token;
        } else if ($rootScope.isSessionStorageSupported) {

          $sessionStorage.Nowness.user = $rootScope.token;
        }

        deferred.resolve(['token set', status]);
      })
      .error(function(data) {

        deferred.reject(data);
      });
    return deferred.promise;
  }

  function resetPassword(id, resetToken, password) {

    var data = {
      resetToken: resetToken,
      password: password
    };

    var token = $rootScope.apiUrlNew + '/user/' + id + '/password';

    return $http.put(token, data);
  }

  function resetToken(email) {

    var target = $rootScope.apiUrlNew + '/user/' + window.encodeURIComponent(email) + '/reset-token';

    return $http.post(target, {});
  }

  function saveLoginSession(id, showInProfile, allowLookup, socialProfileUrl) {

    var data = {
      showInProfile: showInProfile ? true : false,
      allowLookup: allowLookup ? true : false,
      socialProfileUrl: socialProfileUrl ? socialProfileUrl : null
    };

    var target = $rootScope.apiUrlBak + '/login-session/' + id;

    return $http.put(target, data);
  }

  function saveProfile() {

    if ($rootScope.tempProfile) {

      angular.extend($rootScope.profile, $rootScope.tempProfile);
    }

    var target = $rootScope.apiUrlNew + '/user/' + $rootScope.profile.id;

    return $http.put(target, $rootScope.profile);
  }

  function verify(userId, token) {

    var data = null;

    if (token) {
      data = {
        verificationToken: token
      };
    }

    var target = $rootScope.apiUrlNew + '/user/' + userId + '/verify';

    return $http.put(target, data);
  }

  function setRedirectAfterGettingUser({ to }){

    redirectAfterLogin = to
  }

  /**
   *
   * @PRIVATE
   *
   */

  function _isLocalStorageNameSupported() {

    var testKey = 'test';

    try {

      var storage = window.localStorage;
      storage.setItem(testKey, '1');
      storage.removeItem(testKey);
      return true;
    } catch (error) {

      return false;
    }
  }

  function _isSessionStorageNameSupported() {

    var testKey = 'test';

    try {

      var storage = window.sessionStorage;
      storage.setItem(testKey, '1');
      storage.removeItem(testKey);
      return true;
    } catch (error) {

      return false;
    }
  }

  return {

    newLoginStatus: function() {
      return loginStatus;
    },

    checkToken: checkToken,
    deleteLoginSession: deleteLoginSession,
    deleteUser: deleteUser,
    follow: follow,
    followDelete: followDelete,
    getUser: function() {

      if (checkToken()) {

        return getUser();
      } else {

        var deferred = $q.defer();
        deferred.reject('no Token - proceed to login');
        $rootScope.profile = false;
        return deferred.promise;
      }
    },
    getAnotherUser: getAnotherUser,
    getTokenAsAdmin: getTokenAsAdmin,
    logOutAdmin: logOutAdmin,
    isAdminAuthenticated: isAdminAuthenticated,
    getTokenAndUser: getTokenAndUser,
    listUsers: listUsers,
    loginStatus: false,
    logout: logout,
    merge: merge,
    register: register,
    resetPassword: resetPassword,
    resetToken: resetToken,
    saveLoginSession: saveLoginSession,
    saveProfile: saveProfile,
    verify: verify,
    setRedirectAfterGettingUser: setRedirectAfterGettingUser
  };
}

export default apiUserService;



// WEBPACK FOOTER //
// ./app/components/_api/user.service.js